<template>
  <div class="dashboard">
    <div class="dashboard__container">
      <div class="dashboard__container--header flex justify-space-between align-center">
        <h1>New Jump Users</h1>
      </div>
      <div class="dashboard__container--body">
        <Loader v-if="!newUsers || newUsers.length == 0" />
        <vue-good-table
          v-if="newUsers && newUsers.length >= 1"
          :columns="columns"
          :rows="newUsers"
          styleClass="vgt-table condensed"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 20,
          }"
          :search-options="{
            enabled: true,
            placeholder: 'Search this table',
          }"
        >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'created'">
            <span v-if="props.row.created">{{formatDate(props.row.created)}}</span>
          </span>
          <span v-else-if="props.column.field == 'photoUrl'">
            <span v-if="props.row.photoUrl">
              <img :src="(props.row.photoUrl || `https://firebasestorage.googleapis.com/v0/b/mvpes-25aef.appspot.com/o/avatar%20copy.png?alt=media&token=966c07c4-125a-490f-81be-4e2d26bf33fa`)" alt="" style="width: 3.5rem; height:3.5rem; border-radius: 50%; padding: 0.25rem;">
            </span>
          </span>

          <span v-else-if="props.column.field == 'followUp'">
            <span v-if="props.row.address && props.row.address.state && props.row.phone">
              <button class="btn btn__outlined btn__small relative" v-if="!props.row.sendFollowUp" @click="sendFollowUp(props.row)">
                Welcome Text
              </button>

              <button class="btn btn__outlined btn__small relative" v-if="props.row.sendFollowUp">
                Sent <i class="fa-solid fa-check ml-3" style="color:#00C897;"></i>
              </button>
            </span>
          </span>

          <span v-else-if="props.column.field == 'jobs'">

            <span v-if="!props.row.skills || props.row.skills.length == 0">
              <i class="fad fa-briefcase ml-2 mr-2" style="opacity:50%;"></i>
            </span>
            <span v-if="props.row.skills && props.row.skills.length > 0">
              <v-popover>
                <i class="fad fa-briefcase ml-2 mr-2 success"></i>
                <template slot="popover">
                  <span v-for="z in props.row.skills">{{z.title}} / </span>
                </template>
              </v-popover>
            </span>


            <!-- <span v-for="(item, index) in props.row.skills" :key="index">{{item.title}}, </span> -->
          </span>

          <span v-else-if="props.column.field == 'interviewed'">
            <span v-if="props.row.interview && props.row.interview.interviewBy">
              <i class="fas fa-check fa-2x" style="color:green"></i>
            </span>
          </span>
          <span v-else-if="props.column.field == 'link'">
            <router-link :to="`/users/` + props.row.id" target="_blank">
              <i class="fas fa-external-link ml-2 mr-2"></i>
            </router-link>
          </span>


          <span v-else-if="props.column.field == 'workerId'">
   <!--          <div v-if="props.row.workerId && props.row.evereeOnboardingComplete"><i class="fa-solid fa-square-check ml-2 mr-2 success"></i>
            </div> -->

            <button v-if="props.row.evereeOnboardingComplete" class="btn btn__outlined btn__small">
                  Contractor <i class="fa-solid fa-check ml-3" style="color:#00C897;"></i>
                </button>

            <button v-if="!props.row.evereeOnboardingComplete && props.row.updatePayrollReminderSent" class="btn btn__outlined btn__small" @click="onTextPayroll(props.row)">
              Reminder Sent <i class="fa-solid fa-check ml-3" style="color:#00C897;"></i>
            </button>

            <button v-if="!props.row.evereeOnboardingComplete && !props.row.updatePayrollReminderSent" class="btn btn__outlined btn__small" @click="onTextPayroll(props.row)">
              Send Reminder
            </button>
<!-- 
            <button class="btn btn__outlined btn__small relative" v-if="!props.row.sendFollowUp" @click="onTextPayroll(props.row)">
              Payroll Reminder
            </button>

            <button class="btn btn__outlined btn__small relative" v-if="props.row.sendFollowUp">
              Reminder Sent <i class="fa-solid fa-check ml-3" style="color:#00C897;"></i>
            </button>

            <div v-if="props.row.workerId && !props.row.evereeOnboardingComplete"><i class="fa-solid fa-square-check ml-2 mr-2 warning"></i>
            </div>

            <div v-if="!props.row.workerId">
             <i class="fa-solid fa-square-check ml-2 mr-2 danger"></i>
            </div> -->
          </span>


          <span v-else-if="props.column.field == 'groups'">

  <!--           

            <button class="btn btn__outlined btn__small relative" v-if="(!props.row.groups || props.row.groups.length == 0) && !props.row.sendJobsFollowUp" @click="sendJobsFollowUp(props.row)">
              Send Text
            </button>

            <button class="btn btn__outlined btn__small relative" v-if="(!props.row.groups || props.row.groups.length == 0) && props.row.sendJobsFollowUp">
              Reminder Sent <i class="fa-solid fa-check ml-3" style="color:#00C897;"></i>
            </button> -->

            <span v-if="(!props.row.groupApplications || props.row.groupApplications.length == 0) && (!props.row.groups || props.row.groups.length == 0)">
              <i class="fa-solid fa-user-group ml-2 mr-2" style="opacity: 50%;"></i>
            </span>
<!-- 
            <span v-if="props.row.groupApplications && props.row.groupApplications.length > 0">
              <i class="fa-solid fa-user-group ml-2 mr-2 warning"></i>
            </span> -->

            <span v-if="(props.row.groupApplications && props.row.groupApplications.length > 0) || (props.row.groups && props.row.groups.length > 0)">
              <i class="fa-solid fa-user-group ml-2 mr-2 success"></i>
            </span>
          </span>


            
          
          <span v-else-if="props.column.field == 'updatedContact'">
            <span v-if="props.row.updatedContact">{{formatDate(props.row.updatedContact)}}</span>
          </span>
          <!-- <span v-else-if="props.column.field == 'state'">
            <input type="text" v-model.trim="props.row.state" placeholder="CA" id="state" />
          </span> -->
          <span v-else-if="props.column.field == 'status'">
            <v-select
              label="status" 
              :options="statuses"
              v-model="props.row.initialContactStatus"
              @input="updateUser(props.row)"
              :clearable="true"
              >
            </v-select>
          </span>

          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
import router from '@/router'
const fb = require('../../firebaseConfig.js')

export default {
  name: 'newUsers',
  data: () => ({
    performingRequest: false,
    statuses: ['Contacted', 'Not Contacted', 'Interviewed', 'Contractor Only', 'Onboarding as Employee', 'Hired JES', 'Hide'],
    columns: [
      {
        label: '',
        field: 'photoUrl',
        sortable: false,
        width:'42px',
        tdClass: 'text-center',
      },
      {
        label: 'Created',
        field: 'created',
        width: '120px'
      },
      {
        label: 'Send Text',
        field: 'followUp',
        width: '100px',
        sortable: false,
      },
      {
        label: 'Onboarded',
        field: 'workerId',
        width: '60px',
        sortable: false,
        tdClass: 'text-center',
      },
      {
        label: 'Status',
        field: 'status',
        width: '180px'
      },
      {
        label: 'Link',
        field: 'link',
        width: '60px',
        sortable: false,
        tdClass: 'text-center',
      },
      {
        label: 'First Name',
        field: 'firstName',
        width: '100px'
      },
      {
        label: 'Last Name',
        field: 'lastName',
        width: '120px'
      },
      
      {
        label: 'Email',
        field: 'email',
      },
      {
        label: 'Phone',
        field: 'phone',
        width: '120px'
      },
      {
        label: 'Skills',
        field: 'jobs',
        sortable: false,
      },
      {
        label: 'Groups',
        field: 'groups',
        sortable: false,
      },
      {
        label: 'city',
        field: 'address.city',
        width: '120px'
      },
      {
        label: 'state',
        field: 'address.state',
        width: '40px',
      },
      {
        label: 'Updated By',
        field: 'updatedContactBy',
        width: '120px'
      },
      {
        label: 'Last Updated',
        field: 'updatedContact',
        width: '120px'
      }, 
    ]
  }),
  created () {
    this.$store.dispatch("getNewUsers")
  },
  computed: {
    ...mapState(['newUsers', 'userProfile']),
  },
  components: {
    Loader,
  },
  methods: {
    onTextPayroll(user) {
      // user.updatePayrollReminderSent = true
      let newText = {
        name: user.firstName,
        phone: user.phone,
        userId: user.id,
        type: 'updatePayroll'
      }
      this.$store.dispatch('updatePayrollText', newText)
      
      // fb.usersCollection.doc(user.id).update({
      //   updatePayrollReminderSent: fb.firestore.FieldValue.serverTimestamp()
      // })
    },
    sendFollowUp(row) {
      console.log(row)
      fb.usersCollection.doc(row.id).update({
        sendFollowUp: true
      })
    },
    sendJobsFollowUp(row) {
      console.log(row)
      fb.usersCollection.doc(row.id).update({
        sendJobsFollowUp: true
      })
    },
    updateUser(row) {
      fb.usersCollection.doc(row.id).update({
        initialContactStatus: row.initialContactStatus,
        updatedContactBy: this.userProfile.firstName + ' ' + this.userProfile.lastName,
        updatedContact: fb.firestore.FieldValue.serverTimestamp(),
      })
    },
    formatDate(q) {
      if(q) {
        const postedDate = new Date(q.seconds) * 1000;
        return moment(postedDate).format('MMM Do, YYYY')
      } else {
        return null
      }
    },
  },
  beforeDestroy() {
    this.performingRequest = null
    delete this.performingRequest
    delete this.onTextPayroll
    delete this.formatDate
    delete this.updateUser
    delete this.sendJobsFollowUp
    delete this.onTextPayroll
    delete this.sendFollowUp
    this.$store.dispatch("clearNewUsers")
  }
}
</script>

